<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">         
                    <v-form id="form" ref="form">
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <v-select :label="cboPais" :items="lista.pais" return-object v-model="paisComputed"
                                        item-value="id" item-text="nome" :no-data-text="cboPaisSemDados"
                                        required :rules="rules.pais"></v-select>
                                </v-flex>          

                                <v-flex xs12 md6>
                                    <v-select :label="labelMandatorio" :items="lista.simNao" return-object v-model="mandatorio"
                                        item-value="id" item-text="value"></v-select>
                                </v-flex>                                    

                                <v-flex xs12 md6>
                                    <v-select :label="labelMultiplaEscolha" :items="lista.simNao" return-object v-model="multiplaEscolha"
                                        item-value="id" item-text="value"></v-select>
                                </v-flex>                                                                                                                                                                                                

                                <v-flex xs12 md12 class="d-flex justify-center">
                                    <v-btn class="danger" @click="btnLimpar_OnClick">
                                        <v-icon left>mdi-restore</v-icon> 
                                        {{clear}}
                                    </v-btn>                          

                                    <v-btn class="success" @click="btnPesquisar_OnClick">
                                        <v-icon left>mdi-filter</v-icon> 
                                        {{search}}
                                    </v-btn>                                                                                     
                                </v-flex>   
                            </v-layout>
                        </v-container>
                    </v-form> 
                    <br/>

                    <v-data-table :headers="colunas" :items="resultado" class="elevation-1" :footer-props="dataFooter">
                        <template v-slot:[`item.indicadorMandatorio`]="{ item }">  
                            <span v-if="item.indicadorMandatorio">{{yes}}</span>
                            <span v-else>{{no}}</span>
                        </template>     
                        
                        <template v-slot:[`item.dataCadastro`]="{ item }">  
                            {{formatUtcToLocal(item.dataCadastro)}}  
                        </template>                          

                        <template v-slot:[`item.lista`]="{ item }">   
                            <template v-if="item.parametrizacaoOnboardingAtributo.listaValores != null">
                                <a @click="linkDetalhesLista_OnClick(item.parametrizacaoOnboardingAtributo.listaValores.id)">{{item.parametrizacaoOnboardingAtributo.listaValores.nome}}</a>
                            </template>
                        </template>                           

                        <template v-slot:no-data>{{nenhumaParametrizacaoEncontrada}}</template>
                    </v-data-table> 
                </material-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="exibirDetalhesLista" width="600">
            <v-card>
                <v-card-title>
                    <span v-if="lista.indicadorMultiplaEscolha == true">
                        {{lista.valores.descricao}}
                    </span>
                    <span v-else>
                        {{`${lista.valores.descricao} (Multipla escolha)` }}
                    </span>                    
                </v-card-title>
                <v-card-text>
                    <v-data-table 
                        :headers="colunasListaValores" 
                        :items="lista.valores.atributo" 
                        :items-per-page="5" 
                        :footer-props="dataFooter"
                        item-key="id">    
                    </v-data-table> 
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="danger" @click="exibirDetalhesLista = false">
                        {{close}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> 
    </v-container>
</template>

<script>
import DateMixin from '@/mixin/date'
import FormMixin from '@/mixin/form'
import { mapGetters } from 'vuex'

import ParametrizacaoOnboardingApi from '@/api/workspace/onboarding/parametrizacao'
import ParametrizacaoUtil from '../utils/parametrizacao'

export default {
    mixins: [ DateMixin, FormMixin], 
    data () {
        return { 
            lista: {
                pais: [],
                valores: [],
                simNao:[]
            },         
            rules:{
                pais: [
                    val => {
                        if((val || null) == null)
                            return this.cboPaisObrigatorio;

                        return true;
                    }
                ]                          
            },     
            exibirDetalhesLista: false,
            pais: null,    
            paisPadraoUsuario: false,
            multiplaEscolha: null,
            mandatorio: null,
            resultado: [],
            colunas: [
                { text: this.$t("Views.Onboarding.Parametrizacao.Listar.codigo-unico"), align: 'left', value: 'parametrizacaoOnboardingAtributo.codigoUnico' },
                { text: this.$t("Views.Onboarding.Parametrizacao.Listar.descricao"), align: 'left', value: 'parametrizacaoOnboardingAtributo.descricao' },                
                { text: this.$t('Views.Onboarding.Parametrizacao.Listar.mandatorio'), align: 'center', value: 'indicadorMandatorio' },
                { text: this.$t("Views.Onboarding.Parametrizacao.Listar.tipo-dado"), align: 'center', value: 'parametrizacaoOnboardingAtributo.tipoDado.nome' },
                { text: this.$t("Views.Onboarding.Parametrizacao.Listar.tamanho"), align: 'center', value: 'parametrizacaoOnboardingAtributo.tipoDado.tamanho' },
                { text: this.$t("Views.Onboarding.Parametrizacao.Listar.lista-valores"), align: 'center', value: 'lista' },
                { text: this.$t("Views.Onboarding.Parametrizacao.Listar.data-cadastro"), align: 'center', value: 'dataCadastro' }
            ],   
            colunasListaValores: [
                { text: this.$t('Views.Onboarding.Parametrizacao.Listar.codigo-success-factors'), align: 'right', width: 200, value: 'valor' },
                { text: this.$t('Views.Onboarding.Parametrizacao.Listar.descricao-valor'), align: 'left', value: 'descricao' }
            ],                      
        }
    },
    computed: {  
        ...mapGetters("app", ["getUserCountry"]),
        title () {
            return this.$t('Views.Onboarding.Parametrizacao.Listar.form-title');            
        },          
        text () {
            return this.$t('Views.Onboarding.Parametrizacao.Listar.form-text');            
        },
        cboPais(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.pais');            
        },
        cboPaisSemDados(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.nenhum-pais-encontrado');            
        }, 
        cboPaisObrigatorio(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.selecione-pais');            
        },
        codigoUnico(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.codigo-unico');            
        },
        labelMandatorio(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.mandatorio');            
        },
        labelMultiplaEscolha(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.multipla-escolha');            
        },
        utilizaListaValores(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.utiliza-lista-valores');            
        },
        listaValores(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.lista-valores');            
        },
        tipoDado(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.tipo-dado');            
        },
        tamanho(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.tamanho');            
        },
        mascaraFormatacao(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.mascara-formatacao');            
        },
        nenhumaParametrizacaoEncontrada(){
            return this.$t('Views.Onboarding.Parametrizacao.Listar.nenhuma-parametrizacao-encontrada');
        },
        paisComputed: {
            get(){
                if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
                    this.$set(this, "paisPadraoUsuario", true);
                    this.$set(this, "pais", this.getUserCountry);
                }

                return this.pais;
            },
            set(value){
                this.$set(this, "pais", value);
            }
        },                                                                                                                       
    },
    created(){
        this.formUniqueCode = "FORM.ONCO.00002";
        this.privilegeUniqueCode = "SELC";     

        this.$set(this.lista, "simNao", this.createListYesOrNo());
    },
    async mounted(){       
        const loading = this.showLoading();
        await this.listarPais();

        try{
            this.pais = this.$store.state.app.userCountry;
            await this.listarParametrizacao();
        } catch(error){ }
        
        loading.close();
    }, 
    methods:{      
        async listarPais(){
            const paises = await ParametrizacaoOnboardingApi.listarPaises().catch(erro => this.showSnackbarError(erro.error));            

            if(paises.success) {
                this.$set(this.lista, "pais", this.$_.sortBy(paises.data, p => p.nome));
            }
            else {                        
                this.showSnackbarError(paises.error);
                throw new Error(paises.error[0].userMessage);
            }   
        },           
        async listarParametrizacao(){
            const parametrizacao = await ParametrizacaoOnboardingApi.listarPorPais(this.pais.id).catch(erro => this.showSnackbarError(erro.error));

            if(parametrizacao.success && parametrizacao.data != null) {
                let resultado = parametrizacao.data;
                if(this.multiplaEscolha != null){
                    if(this.multiplaEscolha.id == 1)
                        resultado = resultado.filter(p => p.parametrizacaoOnboardingAtributo.listaValores != null &&  p.parametrizacaoOnboardingAtributo.listaValores.indicadorMultiplaEscolha);
                    
                    else
                        resultado = resultado.filter(p => p.parametrizacaoOnboardingAtributo.listaValores == null || p.parametrizacaoOnboardingAtributo.listaValores.indicadorMultiplaEscolha == false);                                
                }

                if(this.mandatorio != null)
                    resultado = resultado.filter(p => p.indicadorMandatorio == (this.mandatorio.id == 1));

                this.resultado = this.$_.sortBy(resultado, p => p.parametrizacaoOnboardingAtributo.descricao);
            }
            else {                     
                this.showSnackbarError(parametrizacao.error);
                throw new Error(parametrizacao.error[0].userMessage);
            }      
        },          
        async btnLimpar_OnClick(){         
            this.$set(this, "resultado", []);
            this.$refs.form.reset();

            if(this.getUserCountry != null){
                this.$nextTick(() => {
                    this.$set(this, "paisPadraoUsuario", false);
                    this.$set(this, "pais", null);
                });
            }                           
        },          
        async btnPesquisar_OnClick(){
            if(!this.$refs.form.validate()) 
                return;

            const loading = this.showLoading();
            await this.listarParametrizacao();
            loading.close();
        },
        async linkDetalhesLista_OnClick(id){
            const loading = this.showLoading();
            const listaValores = await ParametrizacaoUtil.listaValores(id);

            this.$set(this.lista, "valores", listaValores);
            loading.close();

            this.exibirDetalhesLista = true;
        },
        retornarDescricaoBoolean(value){
            if(value)
                return this.$t('Common.yes')            

            return this.$t('Common.no')            
        }      
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
